export default __webpack_public_path__ + "static/media/hana.818da2f8.png";